import React from 'react';
import { SidebarArrow, CrossButton, Info } from './Icons';
import ListFilter from './ListFilter';
import RangeConnectionFilterValue from './RangeConnectionFilterValue';
import RangeFilterDate from './RangeFilterDate';
import RangeFilterValue from './RangeFilterValue';
import ToggleFilter from './ToggleFilter';


const FilterSidebar = (props) => {

  const {
    filterSidebarActive,
    setFilterSidebarActive,
    handleFilterSidebar,
    handleFilter,
    handleFilterEntry,
    handleReset,
    colorPalette,
    statusTypes,
    techTypes,
    regionTypes,
    filterOpen,
    filterActive,
    projectCount,
    dateBounds,
    capacityBounds,
    setDateIndexValue,
    dateFilterActive,
    setDateFilterActive,
    dateRangeRef,
    capacityRangeRef,
    dateIndexValue,
    capacityFilterActive,
    setCapacityFilterActive,
    setCapacityIndexValue,
    setHeatmapLayerActive,
    heatmapLayerActive,
    buildingTypeActive,
    setBoundaryLayerActive,
    boundaryLayerActive,
    today,
    setModalActive,
    sourceTypes,
    connectionBounds,
    connectionFilterActive,
    connectionRangeRef,
    setConnectionFilterActive,
    setConnectionIndexValue,
    heatNetworkType,
    buildingTypes,
    setBuildingTypeActive
  } = props;

  const searchParams = new URLSearchParams(window.location.search);
  const projectType = searchParams.get('type')

  return (
    <div className={(filterSidebarActive) ? 'filter-sidebar-wrapper noselect' : 'filter-sidebar-wrapper filter-sidebar-hidden noselect'}>
      <div onClick={handleFilterSidebar} className='filter-toggle-container'>
        <SidebarArrow className={(filterSidebarActive) ? '' : 'arrow-spin'} />
      </div>
      <div className='filter-sidebar'>

        <div className='filter-title-box'>
          <div className='filter-title-bar'>
            <h1 className='filter-header'> {props.projectType === 'heat_network' ? 'Heat Networks Planning Database' : 'Renewable Energy Planning Database'}</h1>
            <div onClick={() => setFilterSidebarActive(false)}>
              <CrossButton className='cross-button' />
            </div>
          </div>
          <div className='filter-title-container'>
            <h2 className='filter-title color-invert'>{projectCount} {(projectCount === 1) ? "PROJECT" : "PROJECTS"}</h2>

            <div className='reset' onClick={() => handleReset()}>
              RESET
            </div>
          </div>

        </div>

        <div className='filter-content'>

          <ListFilter
            filterValues={colorPalette}
            filterValuesOnly={techTypes}
            filterActive={filterActive}
            filterOpen={filterOpen}
            filterName={'energy'}
            filterTitle={'ENERGY TYPE'}
            handleFilterEntry={handleFilterEntry}
            handleFilter={handleFilter} />

          <RangeFilterValue
            filterName={'capacity'}
            filterTitle={'ENERGY CAPACITY'}
            filterOpen={filterOpen}
            handleFilter={handleFilter}
            valueBounds={capacityBounds}
            capacityBounds={capacityBounds}
            capacityFilterActive={capacityFilterActive}
            setCapacityFilterActive={setCapacityFilterActive}
            capacityRangeRef={capacityRangeRef}
            setIndexValue={setCapacityIndexValue} />

          <ListFilter
            filterValues={statusTypes}
            filterValuesOnly={statusTypes}
            filterActive={filterActive}
            filterOpen={filterOpen}
            filterName={'status'}
            filterTitle={'STATUS'}
            handleFilterEntry={handleFilterEntry}
            handleFilter={handleFilter} />

          <ListFilter
            filterValues={regionTypes}
            filterValuesOnly={regionTypes}
            filterActive={filterActive}
            filterOpen={filterOpen}
            filterName={'region'}
            filterTitle={'REGION'}
            handleFilterEntry={handleFilterEntry}
            handleFilter={handleFilter} />

          <RangeFilterDate
            filterName={'plandate'}
            filterTitle={'APPLICATION DATE'}
            filterOpen={filterOpen}
            handleFilter={handleFilter}
            dateBounds={dateBounds}
            setIndexValue={setDateIndexValue}
            dateFilterActive={dateFilterActive}
            setDateFilterActive={setDateFilterActive}
            dateRangeRef={dateRangeRef}
            dateIndexValue={dateIndexValue}
            today={today} />

          <ListFilter
            filterValues={sourceTypes}
            filterValuesOnly={sourceTypes}
            filterActive={filterActive}
            filterOpen={filterOpen}
            filterName={'source'}
            filterTitle={'PROJECT TYPE'}
            handleFilterEntry={handleFilterEntry}
            handleFilter={handleFilter} />
          {
            projectType === "heat_network" ? (<>
              <ListFilter
                filterValues={heatNetworkType}
                filterValuesOnly={heatNetworkType}
                filterActive={filterActive}
                filterOpen={filterOpen}
                filterName={'heatNetwork'}
                filterTitle={'HEAT NETWORK TYPE'}
                handleFilterEntry={handleFilterEntry}
                handleFilter={handleFilter} />

              <ListFilter
                filterValues={buildingTypes}
                filterValuesOnly={buildingTypes}
                filterActive={filterActive}
                filterOpen={filterOpen}
                filterName={'building'}
                filterTitle={'TYPES OF BUILDING'}
                handleFilterEntry={handleFilterEntry}
                handleFilter={handleFilter} />


              <RangeConnectionFilterValue
                filterName={'noOfCon'}
                filterTitle={'NUMBER OF CONNECTIONS'}
                filterOpen={filterOpen}
                handleFilter={handleFilter}
                valueBounds={connectionBounds}
                connectionBounds={connectionBounds}
                connectionFilterActive={connectionFilterActive}
                setConnectionFilterActive={setConnectionFilterActive}
                connectionRangeRef={connectionRangeRef}
                setIndexValue={setConnectionIndexValue} />

            </>) : ''
          }

          <ToggleFilter
            filterOpen={filterOpen}
            filterName={'layers'}
            filterTitle={'MAP LAYERS'}
            handleFilterEntry={handleFilterEntry}
            handleFilter={handleFilter}
            heatmapLayerActive={heatmapLayerActive}
            setHeatmapLayerActive={setHeatmapLayerActive}
            buildingTypeActive={buildingTypeActive}
            setBuildingTypeActive={setBuildingTypeActive}
            boundaryLayerActive={boundaryLayerActive}
            setBoundaryLayerActive={setBoundaryLayerActive} />

        </div>
      </div>


      <div className='logo-container'>
        <a
          href='https://www.gov.uk/government/organisations/department-for-business-energy-and-industrial-strategy'
          target="_blank"
          rel="noreferrer">
          <img
            className='logo'
            src={process.env.PUBLIC_URL + '/images/DESNZ.png'}
            alt='Department for Business Energy and Insdustrial Strategy' />
        </a>

        <div
          className='info-button-container'
          onClick={() => setModalActive(true)}>
          <Info />
        </div>
      </div>

    </div>
  )
}

export default FilterSidebar;

